import { PermissionAction } from './permissions.model';

// Danger: this map is mirrored in mobile Android's permissions/AdditionalGrantedActions.kt.

/** Actions implied by holding another, e.g. editing alert types also lets you view them. */
export const additionalGrantedActions: Partial<Record<PermissionAction, PermissionAction[]>> = {
    [PermissionAction.EditAdministratorDefinedChannels]: [PermissionAction.ViewAdministratorDefinedChannels],
    [PermissionAction.EditAlertTypes]: [PermissionAction.ViewAlertTypes],
    [PermissionAction.EditCrafts]: [PermissionAction.ViewCrafts],
    [PermissionAction.EditCustomDictionaries]: [PermissionAction.ViewCustomDictionaries],
    [PermissionAction.EditForms]: [PermissionAction.ViewForms],
    [PermissionAction.EditGeofenceTypes]: [PermissionAction.ViewGeofenceTypes],
    [PermissionAction.EditItemTypes]: [PermissionAction.ViewItemTypes],
    [PermissionAction.EditPeople]: [PermissionAction.ViewPeople],
    [PermissionAction.EditPermissions]: [PermissionAction.ViewPermissions],
    [PermissionAction.EditSites]: [PermissionAction.ViewSites],
    [PermissionAction.EditWorkflows]: [PermissionAction.ViewWorkflows],
    [PermissionAction.EditTeamsIntegration]: [PermissionAction.ViewTeamsIntegration],
    [PermissionAction.EditSafetyObservation]: [PermissionAction.ReportSafetyObservation, PermissionAction.ViewSafetyObservation],
    [PermissionAction.EditDeviceManagement]: [PermissionAction.ViewDeviceManagement],
    [PermissionAction.EditSiteLocationSettings]: [PermissionAction.ViewSiteLocationSettings],
    [PermissionAction.EditSiteNetworkSettings]: [PermissionAction.ViewSiteNetworkSettings],
    [PermissionAction.EditSiteSettings]: [PermissionAction.ViewSiteSettings],
    [PermissionAction.EditGeofences]: [PermissionAction.ViewGeofences],
    [PermissionAction.EditFloorPlans]: [PermissionAction.ViewFloorPlans],
    [PermissionAction.EditItems]: [PermissionAction.ViewItems],
    [PermissionAction.EditSiteSafetySettings]: [PermissionAction.ViewSiteSafetySettings],
    [PermissionAction.EditSiteEmergencyResponseSettings]: [PermissionAction.ViewSiteEmergencyResponseSettings],
};

/** Adds every action the listed actions imply to `actions` in place; true when it added any. */
export function addExtraGrantedActions(actions: PermissionAction[]) {
    let found = false;
    actions?.forEach(x => {
        additionalGrantedActions[x]?.forEach(y => {
            if (!actions.includes(y)) {
                found = true;
                actions.push(y);
            }
        });
    });
    return found;
}
